import React, { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Button, Select, TextInput } from 'components/Form'
import { createApiRecord, updateApiRecord } from 'services/UsersService'
import { useDispatch, useSelector } from 'react-redux'
import { getRecord } from './store/dataSlice'
import reducer from './store'
import { injectReducer } from 'store'
import { Field, Form, Formik } from 'formik'
import * as Yup from 'yup'
import { Success } from 'utils/alerts'
import { AiOutlineMail } from 'react-icons/ai'
import { yesNoOptions } from 'utils/options'
injectReducer('users', reducer)

const validationSchema = Yup.object().shape({
    company: Yup.string().required('please select company.'),
    username: Yup.string().nullable(),
    first_name: Yup.string().required('first name field is required.'),
    last_name: Yup.string().required('last name field is required.'),
    role: Yup.string().required('please select role.'),
    email: Yup.string().required('email field is required.'),
    is_ensemble_admin: Yup.boolean().required('please select if user is company admin.'),
    // password: Yup.number().required('password field is required.'),
})

const Create = () => {
    const { id } = useParams()
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const { companyData, customersData, rolesData } = useSelector(state => state.listData)
    const { view, record, loading } = useSelector(state => state.users.data)

    useEffect(() => {
        if (id) {
            fetchData(id)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id])

    const fetchData = id => dispatch(getRecord(id))

    const handleDiscard = () => navigate('/company-management/users')

    const handleSubmit = data => {
        if (id) {
            updateApiRecord(id, data)
                .then(() => {
                    Success('Updated Successfully!')
                    handleDiscard()
                })
                .catch(error => console.log('Error: ', error))
        } else {
            createApiRecord(data)
                .then(() => {
                    Success('Created Successfully!')
                    handleDiscard()
                })
                .catch(error => console.log('Error: ', error))
        }
    }

    if (loading && id) {
        return null
    }

    return (
        <>
            <div className="flex flex-col gap-1 mb-3 sm:flex-row sm:items-center sm:justify-between">
                <h2 className="font-semibold text-black text-title-md2 dark:text-white">Users</h2>
            </div>
            <div className="flex flex-col items-center">
                <div className="w-full xl:w-1/2 bg-white border rounded-sm border-stroke shadow-default dark:border-strokedark dark:bg-boxdark">
                    <div className="px-5 py-3 border-b border-stroke dark:border-strokedark">
                        <h3 className="font-medium text-black dark:text-white">{id ? 'Update User' : 'Add New User'}</h3>
                    </div>
                    <div className="flex flex-col gap-3 p-6">
                        <Formik
                            initialValues={id ? record : view}
                            validationSchema={validationSchema}
                            onSubmit={values => {
                                handleSubmit(values)
                            }}
                        >
                            {({ values, touched, errors }) => (
                                <Form>
                                    <div className="grid grid-cols-1 gap-x-4 gap-y-4">
                                        <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
                                            <Field name="first_name">
                                                {({ field, form }) => (
                                                    <TextInput
                                                        type="text"
                                                        label="First Name"
                                                        name="first_name"
                                                        error={errors.first_name && touched.first_name}
                                                        message={errors.first_name}
                                                        value={values?.first_name}
                                                        onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                    />
                                                )}
                                            </Field>
                                            <Field name="last_name">
                                                {({ field, form }) => (
                                                    <TextInput
                                                        type="text"
                                                        label="Last Name"
                                                        name="last_name"
                                                        error={errors.last_name && touched.last_name}
                                                        message={errors.last_name}
                                                        value={values?.last_name}
                                                        onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                    />
                                                )}
                                            </Field>
                                        </div>
                                        {/* <Field name="username">
                                            {({ field, form }) => (
                                                <TextInput
                                                    type="text"
                                                    label="Username"
                                                    name="username"
                                                    icon={<AiOutlineUser />}
                                                    error={errors.username && touched.username}
                                                    message={errors.username}
                                                    value={values?.username}
                                                    onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                />
                                            )}
                                        </Field> */}
                                        <Field name="company">
                                            {({ field, form }) => (
                                                <Select
                                                    id="company"
                                                    name="company"
                                                    label="Company"
                                                    placeholder="Company"
                                                    value={values?.company}
                                                    options={companyData}
                                                    onChange={e => {
                                                        form.setFieldValue(field.name, e.target.value)
                                                        form.setFieldValue('customer', '')
                                                    }}
                                                    error={touched.company && errors.company}
                                                    message={errors.company}
                                                />
                                            )}
                                        </Field>
                                        <Field name="customer">
                                            {({ field, form }) => (
                                                <Select
                                                    id="customer"
                                                    name="customer"
                                                    label="Customer"
                                                    placeholder="Customer"
                                                    // className="md:col-span-2"
                                                    value={values?.customer}
                                                    options={customersData?.filter(
                                                        item => item?.company?.id?.toString() === values?.company?.toString()
                                                    )}
                                                    onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                    error={touched.customer && errors.customer}
                                                    message={errors.customer}
                                                />
                                            )}
                                        </Field>
                                        <Field name="role">
                                            {({ field, form }) => (
                                                <Select
                                                    id="role"
                                                    name="role"
                                                    label="Role"
                                                    placeholder="Role"
                                                    value={values?.role}
                                                    options={rolesData}
                                                    onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                    error={touched.role && errors.role}
                                                    message={errors.role}
                                                />
                                            )}
                                        </Field>
                                        <Field name="is_ensemble_admin">
                                            {({ field, form }) => (
                                                <Select
                                                    id="is_ensemble_admin"
                                                    name="is_ensemble_admin"
                                                    label="Is Comany Admin"
                                                    placeholder="Select"
                                                    value={values?.is_ensemble_admin}
                                                    options={yesNoOptions}
                                                    onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                    error={touched.is_ensemble_admin && errors.is_ensemble_admin}
                                                    message={errors.is_ensemble_admin}
                                                />
                                            )}
                                        </Field>
                                        <Field name="email">
                                            {({ field, form }) => (
                                                <TextInput
                                                    type="text"
                                                    label="Email"
                                                    name="email"
                                                    icon={<AiOutlineMail />}
                                                    error={errors.email && touched.email}
                                                    message={errors.email}
                                                    value={values?.email}
                                                    onChange={e => {
                                                        form.setFieldValue(field.name, e.target.value)
                                                        form.setFieldValue('username', e.target.value)
                                                    }}
                                                />
                                            )}
                                        </Field>

                                        <Field name="password">
                                            {({ field, form }) => (
                                                <TextInput
                                                    type="text"
                                                    label={id ? 'Reset Password' : 'Password'}
                                                    name="password"
                                                    password={true}
                                                    error={errors.password && touched.password}
                                                    message={errors.password}
                                                    value={values?.password}
                                                    onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                />
                                            )}
                                        </Field>
                                    </div>
                                    <div className="flex items-center justify-end gap-4 mt-3">
                                        <Button
                                            className="h-10 w-18 text-primary border border-primary dark:text-secondary dark:border-secondary"
                                            onClick={handleDiscard}
                                        >
                                            Discard
                                        </Button>
                                        <Button
                                            type="submit"
                                            className="flex items-center justify-center px-6 py-2 text-white transition border rounded-lg cursor-pointer hover:bg-opacity-90 border-primary bg-primary dark:border-secondary dark:bg-secondary"
                                        >
                                            Save
                                        </Button>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Create
